import React, { useEffect, useState } from "react";
import { EventEntry, Rider } from "../../../../../models";
import { IonButton, IonCard, IonCardContent, IonCardTitle, IonCol, IonLabel, IonRow } from "@ionic/react";
import SelectFromAllRiders from "../../../../Rider/SelectFromAllRiders";
import Spinner from "../../../../Spinners/Spinner";
import { updateEventEntry } from "../../../../../utilities/eventEntry/EventEntry";
import { UpdateEventEntryInput } from "../../../../../API";
import SuccessBanner from "../../../../Banners/SuccessBanner";
import ErrorAlert from "../../../../Errors/ErrorAlert";

interface _Props {
    entry: EventEntry
    isSecondRider?: boolean
    onSubmit: Function
}

const EditEntrySelectedRiderCard: React.FC<_Props> = ({entry, isSecondRider, onSubmit}) => {

    const [currentEntry, setCurrentEntry] = useState<EventEntry | null | undefined>();
    const [currentRider, setCurrentRider] = useState<Rider | null | undefined>();
    const [isLoading, setIsLoading] = useState(false);
    const [isCollapsed, setIsCollapsed] = useState(true);
    const [success, setSuccess] = useState("");
    const [error, setError] = useState("");

    const getEntryInfo = (entry: EventEntry) => {
        setCurrentEntry(entry);
        if (isSecondRider && entry.secondRider) {
            setCurrentRider(entry.secondRider);
        } else if (entry.rider) {
            setCurrentRider(entry.rider);
        }
    }

    useEffect(() => {
        if (entry) {
            getEntryInfo(entry);
        }
    }, [entry, isSecondRider]);

    const handleSave = async () => {
        setIsLoading(true);
        setError("");
        setSuccess("");

        let input: UpdateEventEntryInput = {
            id: entry.id
        };

        if (isSecondRider) {
            input["secondRiderId"] = currentRider?.id || "";
            input["secondRiderName"] = currentRider?.name || "";
        } else {
            input["riderId"] = currentRider?.id || "";
            input["riderName"] = currentRider?.name || "";
        }

        const updateResult = await updateEventEntry(input);
        if (updateResult.isSuccess) {
            const message = "Successfully updated the" + (isSecondRider ? " second " : "") + "rider listed on this entry.";
            setSuccess(message);
            const updatedEntry = updateResult.result;
            onSubmit(updatedEntry);
        } else {
            setError("Error - this entry could not be updated with the selected rider.")
        }

        setIsLoading(false);
    }

    return (
        <>
            {currentEntry && (
                <>
                    <IonCard color="white" className="ion-padding">
                        <IonCardTitle>
                            <IonRow onClick={() => setIsCollapsed(!isCollapsed)}>
                                <IonCol>
                                    <h4>Rider{isSecondRider && " #2"} in Database</h4>
                                </IonCol>
                                <IonCol className="ion-text-right">
                                    <p>{isCollapsed ? "Expand" : "Collapse"}</p>
                                </IonCol>
                            </IonRow>
                        </IonCardTitle>
                        {!isCollapsed && (
                            <IonCardContent>
                                <IonRow>
                                    <IonCol size="12">
                                        <p className="description">This entry has selected the following rider from the RingSide Pro database.</p>
                                        <p className="description">You can find a different rider in the database to list on this entry. Then click save to update this entry.</p>
                                        <p className="description">Or keep the selected rider, and scroll down to edit the info for this rider.</p>
                                    </IonCol>
                                </IonRow>
                                <hr/>
                                <IonRow className="ion-justify-content-center">
                                    {success && <SuccessBanner success={success} width="12" />}
                                    {error && <ErrorAlert error={error} width="12" />}
                                </IonRow>
                                <IonRow>
                                    <IonCol size="12">
                                        <IonLabel position="stacked">
                                            <p>Selected Rider from Database</p>
                                            <span className="description-smaller">(start typing to filter options in the dropdown)</span>
                                        </IonLabel>
                                        <SelectFromAllRiders selectedValue={currentRider?.id} onSelect={(rider: Rider) => setCurrentRider(rider)} />
                                    </IonCol>
                                </IonRow>
                                <IonRow>
                                    <IonCol size="12">
                                        <p className="description">Rider's RingSide Pro id: {currentRider ? currentRider.id : "unknown"}</p>
                                    </IonCol>
                                </IonRow>
                                {isLoading ?
                                    <Spinner />
                                    :
                                    <IonRow className="ion-justify-content-center">
                                        <IonCol sizeMd="4" className="ion-text-center">
                                            <IonButton
                                                className="ion-margin-top"
                                                color="tertiary"
                                                expand="block"
                                                onClick={handleSave}
                                            >
                                                Save
                                            </IonButton>
                                        </IonCol>
                                    </IonRow>
                                }
                            </IonCardContent>
                        )}
                    </IonCard>
                </>
            )}
        </>
    );
};

export default EditEntrySelectedRiderCard;